export enum DegreeOfRelationshipEnum {
  Pai = "PAI",
  Mae = "MAE",
  Tutor = "TUTOR",
  Responsavel = "RESPONSAVEL",
}
